import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { onMounted, ref, watch } from "vue";
import { AttributeSchema, AttributeLayoutProps } from "@/types";
import { attributeApiStore, attributeLayoutSaveStore } from "@/hooks";
import {
  AttributeGrid,
  ArtifactTypeInput,
  FlexBox,
  PanelCard,
  Typography,
  IconButton,
  TextButton,
  TextInput,
} from "@/components/common";


/**
 * Allows for editing attribute layouts.
 */
const __default__ = {
  name: "SaveAttributeLayout",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    layout: {}
  },
  emits: ["save"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const store = ref(attributeLayoutSaveStore(props.layout?.id || ""));

/**
 * Saves an attribute layout.
 */
function handleSave() {
  attributeApiStore.handleSaveAttributeLayout(
    store.value.editedLayout,
    store.value.isUpdate,
    {
      onSuccess: ({ id }) => emit("save", id),
    }
  );
}

/**
 * Deletes an attribute layout.
 */
function handleDeleteLayout() {
  attributeApiStore.handleDeleteAttributeLayout(store.value.editedLayout);
}

/**
 * Deletes an attribute from the layout.
 */
function handleDeleteAttribute(attribute: AttributeSchema) {
  store.value.deleteAttribute(attribute);
}

onMounted(() => store.value.resetLayout(props.layout));

watch(
  () => props.layout,
  () => store.value.resetLayout(props.layout)
);

return (_ctx: any,_cache: any) => {
  const _component_q_space = _resolveComponent("q-space")!

  return (_openBlock(), _createElementBlock("div", null, [
    (store.value.isCustom)
      ? (_openBlock(), _createBlock(_unref(FlexBox), {
          key: 0,
          column: "",
          b: "3"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TextInput), {
              modelValue: store.value.editedLayout.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((store.value.editedLayout.name) = $event)),
              label: "Name",
              "data-cy": "input-attribute-layout-name"
            }, null, 8, ["modelValue"]),
            _createVNode(_unref(ArtifactTypeInput), {
              modelValue: store.value.editedLayout.artifactTypes,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((store.value.editedLayout.artifactTypes) = $event)),
              multiple: "",
              hint: "The layout only appears on these types.",
              "error-message": store.value.typeErrors,
              class: "full-width",
              "data-cy": "input-attribute-layout-artifact-types"
            }, null, 8, ["modelValue", "error-message"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_unref(PanelCard), null, {
      default: _withCtx(() => [
        _createVNode(_unref(AttributeGrid), {
          editable: "",
          layout: store.value.editedLayout
        }, {
          item: _withCtx(({ attribute }) => [
            (!!attribute)
              ? (_openBlock(), _createBlock(_unref(PanelCard), {
                  key: 0,
                  class: "q-ma-sm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(FlexBox), {
                      align: "center",
                      justify: "between"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createVNode(_unref(Typography), {
                            value: attribute.label
                          }, null, 8, ["value"]),
                          _hoisted_1,
                          _createVNode(_unref(Typography), {
                            variant: "caption",
                            value: attribute.key
                          }, null, 8, ["value"])
                        ]),
                        _createVNode(_unref(IconButton), {
                          icon: "delete",
                          tooltip: "Remove from layout",
                          color: "negative",
                          onClick: ($event: any) => (handleDeleteAttribute(attribute))
                        }, null, 8, ["onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["layout"])
      ]),
      _: 1
    }),
    _createVNode(_unref(FlexBox), {
      justify: "between",
      b: "4"
    }, {
      default: _withCtx(() => [
        (store.value.isCustom && store.value.isUpdate)
          ? (_openBlock(), _createBlock(_unref(TextButton), {
              key: 0,
              text: "",
              label: "Delete",
              icon: "delete",
              "data-cy": "button-attribute-layout-delete",
              onClick: handleDeleteLayout
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_q_space),
        _createVNode(_unref(TextButton), {
          label: "Save",
          disabled: !store.value.canSave,
          icon: "save",
          "data-cy": "button-attribute-layout-save",
          onClick: handleSave
        }, null, 8, ["disabled"])
      ]),
      _: 1
    })
  ]))
}
}

})